<script>
  import Menu from "../components/Menu.svelte";
  import Question from "../components/Question.svelte";
  import Result from "../components/Result.svelte";
  import Footer from "../components/Footer.svelte";

  import surveyES from "../utils/surveyES";
  import surveyEN from "../utils/surveyEN";
  import surveyPT from "../utils/surveyPT";
  import surveyDE from "../utils/surveyDE";
  import surveyFR from "../utils/surveyFR";
  import surveyIT from "../utils/surveyIT";
  import {
    dictionary_ES,
    dictionary_EN,
    dictionary_PT,
    dictionary_DE,
    dictionary_FR,
    dictionary_IT,
  } from "../utils/dictionary";

  import { countries } from "../data/countries";

  import { onMount } from "svelte";

  let survey = surveyES;

  let answerMap = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
  let weightMap = [10, 8, 3, 6, 7, 5, 8, 4, 5, 8];

  let rank = -1;
  let rankImage = "";
  let rankText = "";
  let rankColor = "";

  let errorMsg = "";

  let dictionary = dictionary_ES;

  let ip = "";
  let country = "";

  let map = null;

  let selectedCharts = "alltimes";

  const COVID_API_SERVER = "https://covid.catedraavenzoar.es/api/";
  const IPSTACK_SERVER = "https://api.ipstack.com/";
  const IPSTACK_TOKEN = "b3f616ab243f97b5cb8bae924e960616";

  onMount(async () => {
    detectLanguage();
    try {
      let result = await fetch(COVID_API_SERVER + "GetIP.php");
      ip = await result.text();

      result = await fetch(
        IPSTACK_SERVER + ip + "?access_key=" + IPSTACK_TOKEN
      );
      let resultJ = await result.json();
      country = resultJ.country_code.toLowerCase();
      console.log(country);
    } catch (e) {
      console.log(e);
      ip = "";
      country = "";
    }
    await getResults();
  });

  let detectLanguage = () => {
    const userLang = navigator.language || navigator.userLanguage;
    const codes = userLang.split("-");
    const code = codes[0].toUpperCase();
    switch (userLang) {
      case "ES":
        survey = surveyES;
        changeDictionary("es");
        break;
      case "PT":
        survey = surveyPT;
        changeDictionary("pt");
        break;
      case "DE":
        survey = surveyDE;
        changeDictionary("de");
        break;
      case "FR":
        survey = surveyFR;
        changeDictionary("fr");
        break;
      case "IT":
        survey = surveyIT;
        changeDictionary("it");
        break;
      default:
        survey = surveyEN;
        changeDictionary("en");
        break;
    }
  };

  let calculate = async () => {
    errorMsg = "";
    const completed = answerMap.reduce((acc, curr) => {
      return acc && curr !== -1;
    }, true);
    if (completed) {
      let rankMap = survey.map((item, index) => {
        let value = item.inverted ? 5 - answerMap[index] : answerMap[index];
        value = value / 5;
        let wValue = value * weightMap[index];
        return wValue;
      });
      const wSum = weightMap.reduce((acc, curr) => {
        return acc + curr;
      }, 0);
      const sum = rankMap.reduce((acc, curr) => {
        return acc + curr;
      }, 0);
      rank = (sum / wSum) * 100;
      if (rank >= 0 && rank < 20) {
        rankImage = "/images/results-very-bad.svg";
      }
      if (rank >= 20 && rank < 40) {
        rankImage = "/images/results-bad.svg";
      }
      if (rank >= 40 && rank < 60) {
        rankImage = "/images/results-normal.svg";
      }
      if (rank >= 60 && rank < 80) {
        rankImage = "/images/results-good.svg";
      }
      if (rank >= 80 && rank <= 100) {
        rankImage = "/images/results-very-good.svg";
      }

      if (rank < 40) {
        rankText = dictionary.rankText1;
        rankColor = "var(--covid-red-box)";
      }
      if (rank >= 40 && rank < 70) {
        rankText = dictionary.rankText2;
        rankColor = "var(--covid-orange-box)";
      }
      if (rank >= 70) {
        rankText = dictionary.rankText3;
        rankColor = "var(--covid-green-box)";
      }

      await sendResults();
      await getResults();
    } else {
      errorMsg = dictionary.errorMsg;
    }
  };

  let changeDictionary = (lang) => {
    switch (lang) {
      case "es":
        dictionary = dictionary_ES;
        survey = surveyES;
        break;
      case "en":
        dictionary = dictionary_EN;
        survey = surveyEN;
        break;
      case "pt":
        dictionary = dictionary_PT;
        survey = surveyPT;
        break;
      case "de":
        dictionary = dictionary_DE;
        survey = surveyDE;
        break;
      case "fr":
        dictionary = dictionary_FR;
        survey = surveyFR;
        break;
      case "it":
        dictionary = dictionary_IT;
        survey = surveyIT;
        break;
    }
  };

  let sendResults = async () => {
    await fetch(COVID_API_SERVER + "SendResults.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        countryCode: country,
        results: rank,
      }),
    });
  };

  let getResults = async () => {
    //console.log(selectedCharts);

    let startDate = "";
    let endDate = "";
    if (selectedCharts !== "alltimes") {
      const today = moment();
      endDate = today.format("YYYY-MM-DD");
      switch (selectedCharts) {
        case "3months":
          startDate = moment(today).subtract(3, "months");
          break;
        case "lastmonth":
          startDate = moment(today).subtract(1, "months");
          break;
        case "15days":
          startDate = moment(today).subtract(15, "days");
          break;
      }
      console.log(startDate.format("YYYY-MM-DD"));
    }

    const response = await fetch(COVID_API_SERVER + "GetResults.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        startDate,
        endDate,
      }),
    });
    const data = await response.json();

    let countryList = [];
    data.forEach((item) => {
      let cL = countryList.find((cl) => {
        return cl.id === item.countryCode;
      });
      if (!cL) {
        cL = {
          id: item.countryCode,
          results: [],
        };
        countryList.push(cL);
      }
      cL.results.push(parseInt(item.results));
    });

    let countryResults = [];
    countryList.forEach((cL) => {
      const sum = cL.results.reduce((acc, curr) => {
        return acc + curr;
      }, 0);
      const average = Math.round(sum / cL.results.length);
      //console.log(average);
      countryResults[cL.id.toUpperCase()] = average;
    });

    //console.log(countryResults);

    let map = window.$("#map");
    map.empty();
    map.vectorMap({
      map: "world_mill",
      backgroundColor: "#AED1F9",
      borderColor: "F4F3EF",
      color: "#F4F3EF",
      hoverOpacity: 0.7,
      selectedColor: "#CDD8E0",
      enableZoom: true,
      enableDrag: true,
      showTooltip: true,
      normalizeFunction: "lineal",
      hoverOpacity: 0.7,
      hoverColor: false,
      series: {
        regions: [
          {
            scale: ["#ef3434", "#009334"],
            attribute: "fill",
            values: countryResults,
            normalizeFunction: "linear",
            min: 0,
            max: 100,
          },
        ],
      },
      onRegionTipShow: function (e, el, code) {
        const countryName = countries[code.toUpperCase()];
        const countryPoint = countryResults[code]
          ? "<br/><strong>" + countryResults[code] + "</strong>"
          : "";
        el.html("<strong>" + countryName + "</strong>" + countryPoint);
      },
    });
  };

  $: {
    if (rankText !== "") {
      if (rank < 40) {
        rankText = dictionary.rankText1;
      }
      if (rank >= 40 && rank < 70) {
        rankText = dictionary.rankText2;
      }
      if (rank >= 70) {
        rankText = dictionary.rankText3;
      }
    }
  }

  $: {
    if (errorMsg !== "") {
      errorMsg = dictionary.errorMsg;
    }
  }

  //$: console.log(selectedCharts);
</script>

<Menu onChangeDictionary={changeDictionary} />

<!-- Page Content -->
<div class="container">
  <div
    class="alert alert-secondary alert-dismissible fade show msg"
    role="alert"
  >
    {dictionary.mensajeInicial}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  {#each survey as question, index}
    <Question
      {question}
      bind:answerMap
      numQuestion={index}
      finished={rank !== -1}
    />
  {/each}
  {#if errorMsg !== ""}
    <div
      class="alert alert-danger alert-dismissible fade show alertMsg"
      role="alert"
      id="result"
    >
      {errorMsg}
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  {/if}
  {#if rank === -1}
    <div class="button">
      <button
        type="button"
        class="btn btn-primary btn-lg"
        on:click={() => calculate()}
      >
        {dictionary.calcular}
      </button>
    </div>
  {:else}
    <Result {rank} {rankImage} {rankText} {rankColor} {survey} {answerMap} />
  {/if}
  <div class="map">
    <span>{dictionary.resultadosGlobales}</span>
    <!-- svelte-ignore a11y-no-onchange -->
    <select bind:value={selectedCharts} on:change={() => getResults()}>
      <option value="alltimes"> {dictionary.todo} </option>
      <option value="3months"> {dictionary.months3} </option>
      <option value="lastmonth"> {dictionary.lastmonth} </option>
      <option value="15days"> {dictionary.days15} </option>
    </select>

    <div id="map" style="margin:0 auto; width:100%; height:520px;" />
  </div>

  <div class="socialMedia">
    <div>{dictionary.comparte}:</div>
    <div>
      <a
        href="https://www.facebook.com/sharer/sharer.php?u=http://covid.catedraavenzoar.es&t=COVID-19"
        onclick="javascript:window.open(this.href, '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return
        false;"
        target="_blank"
        title="Share on Facebook"
      >
        <img src="/images/social/facebook.svg" alt="Share on Facebook" />
      </a>
      <a
        href="whatsapp://send?text=http://covid.catedraavenzoar.es"
        data-action="share/whatsapp/share"
        onClick="javascript:window.open(this.href, '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return
        false;"
        target="_blank"
        title="Share on whatsapp"
      >
        <img src="/images/social/whatsapp.svg" alt="Share on Whatsapp" />
      </a>
    </div>
  </div>
</div>
<Footer />

<style>
  div.button {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  div.button button {
    background-color: var(--covid-title-blue) !important;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 40px;
    padding-left: 40px;
    margin-top: 20px;
  }

  div.msg {
    border-radius: 10px;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: justify;
    font-size: 14px;
  }

  div.alertMsg {
    margin-top: 50px;
  }

  div.socialMedia {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 11pt;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  div.socialMedia img {
    width: 30px;
    margin-left: 10px;
  }

  div.map {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
  }

  div.map span {
    font-size: 1.25rem;
    color: var(--covid-title-blue);
    font-weight: 500;
    margin-bottom: 10px;
  }

  div.map select {
    max-width: 300px;
    margin-bottom: 14px;
  }

  /* Mobile phones */

  @media only screen and (max-width: 768px) {
    div.socialMedia {
      width: 100%;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
    }

    div.socialMedia div {
      margin-bottom: 15px;
    }

    div.socialMedia img {
      width: 60px;
    }
  }
</style>
